// 홈 화면 앱 센터 섹션 — 출시된 앱 바로가기 + 준비중 슬롯
import React from 'react';
import './MainAppCenter.css';

const APPS = [
  {
    id: '1',
    name: '디지털선교사',
    iconUrl: '',
    url: 'https://script.google.com/macros/s/AKfycbxdYD0iia-bxSrC9Vw6dWf_tKJRn0j2qNdrYDbskylliHnKh9QXQ6d4aUQvaGPdz6AvxQ/exec',
    gradient: 'linear-gradient(135deg, #145351 0%, #236664 100%)',
  },
  {
    id: '2',
    name: '바이블가이드',
    iconUrl: '',
    url: 'https://script.google.com/macros/s/AKfycbwhhnjwqrA2THRcFn0DH26_Gz7KAyWWqG1XRhLNJD1_bZrrCbXkC3rNgomJwikHUx92/exec',
    gradient: 'linear-gradient(135deg, #2b5876 0%, #4e4376 100%)',
  },
  {
    id: '3',
    name: 'ADRA 긴급구호',
    iconUrl: '',
    url: 'https://script.google.com/macros/s/AKfycbzmjR41a5jeM-hkneZfe_33aoIswQOJUPTryEFHiM52FhUV5zkSMp9ESPXK8ZroMREs/exec',
    gradient: 'linear-gradient(135deg, #e65c00 0%, #f9d423 100%)',
  },
  {
    id: '4',
    name: 'EMS 행사관리',
    iconUrl: '',
    url: 'https://ems.sekc.or.kr',
    gradient: 'linear-gradient(135deg, #4776E6 0%, #8E54E9 100%)',
  },
];

// 총 슬롯 7개 — 출시 3개 + 준비중 4개
const TOTAL_SLOTS = 7;
const PLACEHOLDER_COUNT = TOTAL_SLOTS - APPS.length;

const MainAppCenter = () => {
  return (
    <div className="mac-wrapper">
      <div className="mac-section">

        <div className="mac-desc">
          <div className="mac-desc-header">
            <h2 className="mac-title">앱 센터</h2>
            <span className="mac-label">App Center</span>
          </div>
          <p className="mac-body">
            AI 대항해시대,<br />
            영남합회는 디지털 서비스를 선도합니다.
          </p>
        </div>

        <div className="mac-grid">
          {APPS.map((app) => (
            <a
              key={app.id}
              href={app.url}
              target="_blank"
              rel="noopener noreferrer"
              className="mac-item"
            >
              <div className="mac-icon" style={{ background: app.gradient }}>
                {app.iconUrl ? (
                  <img src={app.iconUrl} alt={app.name} className="mac-icon-img" />
                ) : (
                  <span className="mac-icon-initial">{app.name.charAt(0)}</span>
                )}
              </div>
              <span className="mac-name">{app.name}</span>
            </a>
          ))}
          {Array.from({ length: PLACEHOLDER_COUNT }).map((_, i) => (
            <div key={`p${i}`} className="mac-item mac-item--empty">
              <div className="mac-icon mac-icon--empty" />
              <span className="mac-name mac-name--empty">준비중</span>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default MainAppCenter;
